import { connect } from 'react-redux';

import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { getFormInitialValues, getFormValues } from 'redux-form';

import GenericFormContainer from '../../Forms/GenericFormContainer';

import { lengthValidation120, required } from '../../Forms/utils';
import { getRoleIdByName } from '../../Person/utils';

import { roleNames } from '../../Person/constants';
import { CREATE_FOLDER_FORM } from '../constants';

import { CHECKBOX, MESSAGE, STYLED_TEXT } from '../../Forms/fieldTypes';

const CreateFolderFormComponent = (props) => {
  const {
    form,
    formValues,
    formInitialValues,
    onSubmit,
    directoryData,
    isEditAction,
    initialValues,
  } = props;
  const isSubmitDisabled = !formValues?.name;
  const isUpdateDisabled =
    isEditAction && isEqual(formInitialValues, formValues);
  const allowedRoles = get(directoryData, 'allowedRoles', []);

  const formData = [
    {
      keyName: 'name',
      label: 'Folder Name',
      fieldType: STYLED_TEXT,
      validate: [required, lengthValidation120],
    },
    {
      keyName: 'viewAccessTitle',
      value: 'Folder can be viewed by:',
      fieldType: MESSAGE,
      validate: [],
    },
    {
      keyName: 'pm',
      label: 'Property Manager',
      fieldType: CHECKBOX,
      validate: [],
      disabled: true,
    },
    {
      keyName: 'pmcOwner',
      label: 'PMC Owner',
      fieldType: CHECKBOX,
      validate: [],
      disabled: true,
    },
    {
      keyName: 'super',
      label: 'Superintendent',
      fieldType: CHECKBOX,
      validate: [],
      isHidden: !allowedRoles.includes(
        getRoleIdByName(roleNames.superintendent),
      ),
    },
    {
      keyName: 'handyman',
      label: 'Handyman',
      fieldType: CHECKBOX,
      validate: [],
      isHidden: !allowedRoles.includes(getRoleIdByName(roleNames.handyman)),
    },
    {
      keyName: 'concierge',
      label: 'Concierge',
      fieldType: CHECKBOX,
      validate: [],
      isHidden: !allowedRoles.includes(getRoleIdByName(roleNames.concierge)),
    },
    {
      keyName: 'broker',
      label: 'Broker',
      fieldType: CHECKBOX,
      validate: [],
      isHidden: !allowedRoles.includes(getRoleIdByName(roleNames.broker)),
    },
    {
      keyName: 'owner',
      label: 'Owner',
      fieldType: CHECKBOX,
      validate: [],
      isHidden:
        !allowedRoles.includes(getRoleIdByName(roleNames.owner)) ||
        directoryData.isPmcDirectory,
    },
    {
      keyName: 'tenant',
      label: 'Tenant',
      fieldType: CHECKBOX,
      validate: [],
      isHidden:
        !allowedRoles.includes(getRoleIdByName(roleNames.tenant)) ||
        directoryData.isPmcDirectory,
    },
    {
      keyName: 'boardMember',
      label: 'Board Member',
      fieldType: CHECKBOX,
      validate: [],
      isHidden:
        !allowedRoles.includes(getRoleIdByName(roleNames.board_member)) ||
        directoryData.isPmcDirectory,
    },
  ];

  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onSubmit={onSubmit}
      submitText={isEditAction ? 'Update' : 'Create'}
      isButtonDisabled={isSubmitDisabled || isUpdateDisabled}
      backButton={false}
      initialValues={initialValues}
      isEditAction={isEditAction}
      enableReinitialize
    />
  );
};

const mapStateToProps = (state) => ({
  formValues: getFormValues(CREATE_FOLDER_FORM)(state),
  formInitialValues: getFormInitialValues(CREATE_FOLDER_FORM)(state),
  enableReinitialize: true,
  directoryDataForEdit: get(state, 'documentLibrary.directoryDataForEdit', {}),
  directoryData: get(state, 'documentLibrary.directoryData', {}),
});

CreateFolderFormComponent.defaultProps = {
  isEditAction: false,
  formValues: {},
  formInitialValues: {},
};

CreateFolderFormComponent.propTypes = {
  isEditAction: PropTypes.bool,
  directoryData: PropTypes.instanceOf(Object).isRequired,
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.string.isRequired,
  formValues: PropTypes.instanceOf(Object),
  formInitialValues: PropTypes.instanceOf(Object),
  initialValues: PropTypes.instanceOf(Object).isRequired,
};

export default compose(connect(mapStateToProps, null))(
  CreateFolderFormComponent,
);
